import React from 'react';
import { CreatorProfileSvg } from '../assets/CreatorProfileSvg';

/**
 * BackgroundWrapper - A responsive container that uses CreatorProfileSvg as a background
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to be displayed on top of the background
 * @param {string} props.className - Additional classes to be applied to the outer container
 * @param {string} props.contentClassName - Additional classes to be applied to the content container
 * @param {string} props.backgroundClassName - Additional classes to be applied to the background container
 * @param {string} props.color - Color to be used for the SVG background (hex format)
 * @param {number} props.shadowOpacity - Opacity value for shadows (0-1)
 * @param {Object} props.svgProps - Props to be passed to the CreatorProfileSvg component
 * @returns {JSX.Element}
 */
const BackgroundWrapper = ({
  children,
  className = '',
  contentClassName = '',
  backgroundColor = '',
  color = '#00FF99',
  shadowOpacity = 0.5,
  svgProps = {},
  ...rest
}) => {
  return (
    <div className={`relative will-change-auto ${className}`} {...rest}>
      {/* SVG Background container */}
      <div
        className={`rounded-b-lg overflow-hidden aspect-[1225/75] w-full`}
        style={{ backgroundColor }}
      >
        <CreatorProfileSvg
          className="w-full h-full object-cover"
          color={color}
          shadowOpacity={shadowOpacity}
          {...svgProps}
        />
      </div>

      {/* Content container with z-index to appear above the background */}
      <div className={`relative z-10 ${contentClassName}`}>{children}</div>
    </div>
  );
};

export default BackgroundWrapper;
